import { Component, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { StructureViewerLayer } from 'src/app/shared/structureviewermaps/structureviewerlayers';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';
import {ParkingStructurePointItem} from 'src/app/shared/structureviewermaps/structureviewermapitem';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-lprsearch',
    templateUrl: './lprsearch.component.html',
    styleUrls: ['./lprsearch.component.scss'],
    standalone: false
})
export class LprsearchComponent implements AfterViewInit, OnDestroy {

  @ViewChild("Datalistview")
  public Datalistview!: DatalistviewComponent;

  private rowSelectedSubscription: Subscription | undefined;


  constructor() { }


  public Columns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Plate", "PlateNumber"),
    new Datalistviewcolumn("Location", "GuidanceName"),
    new Datalistviewcolumn("Bay Entry", "BayEntry")
  ];

  public StructureViewerLayers: StructureViewerLayer[] = [
      new StructureViewerLayer("ParkingLot")
    ]

  ngAfterViewInit(): void {
    this.rowSelectedSubscription = this.Datalistview.RowSelected.subscribe(row => {
      
      
      var layer = {
        "Type": "CustomPointItem",
        "Items": [
          {
            "Id": row.Id,
            "Name": row.PlateNumber,
            "ParentId": null,
            "GeoLocationPoints": row.LocationPoints,
            "Reroute": "/parking/guidance/lprsearch/" + row.Id
          }
        ]
      }

      this.Datalistview.StructureViewer.AddOrReplaceCustomLayer(layer);
    });

  }

  ngOnDestroy(): void {
    if (this.rowSelectedSubscription) {
      this.rowSelectedSubscription.unsubscribe();
    }
  }

}
